<template>

<BasePanel 
        headline="lang_CONTRACTS_LABEL_EDIT_PANEL_CAPTION_TRACKS_RELEASES"
        :alvqa="alvqa"
    >

    <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="300"
                :page.sync="currentPage"
                :server-items-length="totalRecords"
                :options.sync="options"
                :loading="isLoading"
                :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
                :no-results-text="$t('lang_GENERAL_LOADING_DATATABLE')"
                @update:options="updatePagingSortingOptions"
            >
        
         <!-- Headers -->
            <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
            </template>
        
        <!-- Items -->
            <template v-slot:[`item.trackTitle`]="{ item }">
                <div class="ellipsis">
                    <BaseTooltip
                        :simpleText="item.title"
                        :alvqa="alvqa + '-list-row-text-track-title'"
                    />
                </div>
            </template>
            <template v-slot:[`item.selectedReleases`]="{ item }">
                <div class="ellipsis">
                    <BaseTooltip>
                        <template v-slot:text>{{ getSelectedReleasesTooltip(item) }}</template>
                        <template v-slot:content>
                            <span :alvqa="alvqa + '-list-row-text-release-title'">
                                {{ getSelectedReleasesText(item) }}
                            </span>
                        </template>
                    </BaseTooltip>
                </div>
            </template>
            <template v-slot:[`item.displayArtist`]="{ item }">
                <div class="ellipsis">
                    <BaseTooltip
                        :simpleText="item.displayArtist"
                        :alvqa="alvqa + '-list-row-text-display-artist'"
                    />
                </div>
            </template>
            <template v-slot:[`item.isrc`]="{ item }">
                <div :alvqa="alvqa + '-list-row-text-isrc'">
                    {{ item.isrc }}
                </div>
            </template>
        </v-data-table>
        <v-pagination   
                v-if="numberOfPages > 1"
                total-visible="10" 
                v-model="currentPage" 
                :length="numberOfPages"
                color="pagination"
                @input="nextPage()"
            ></v-pagination>
    </template>
</BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
     name: 'TracksReleasesReadOnlyPanel',
     components: {
        BasePanel,
        BaseButton,
        BaseIcon,
        BaseTooltip
    },
    data() {
        return {
            alvqa: 'contracts-label-read-only-panel-tracks-releases'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_CONTRACTS_LABEL_CAPTION_TRACKS_TITLE"), 
                    align: "left", 
                    value: "trackTitle",
                    class: 'text-no-wrap',
                    sortable: true,
                    alvqa: this.alvqa + '-header-track-title'
                },
                {
                    text: this.$t("lang_CONTRACTS_LABEL_CAPTION_RELEASE_TITLE"), 
                    align: "left", 
                    value: "selectedReleases",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-release-title'
                },
                {
                    text: this.$t("lang_LABEL_TRACKS_CAPTION_DISPLAY_ARTIST"), 
                    align: "left", 
                    value: "displayArtist",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-display-artist'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_ISRC"), 
                    align: "left", 
                    value: "isrc",
                    class: 'text-no-wrap',
                    width: '150px',
                    sortable: false,
                    alvqa: this.alvqa + '-header-isrc'
                },
            ]
        },

        listItems() { return this.$store.getters.getLabelContractsTracksReleases },

        // Paging
        currentPage: {
            get() { return this.$store.getters.getLabelContractsTracksReleasesCurrentPage },
            set(page) { this.$store.commit('setLabelContractsTracksReleasesCurrentPage', page)}
        },
        numberOfPages() { return this.$store.getters.getLabelContractsTracksReleasesNumberOfPages },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        totalRecords() { return this.$store.getters.getLabelContractsTracksReleasesTotalRecords },
        isLoading() { return this.$store.getters.getIsLoading },

        options: { 
            get() { return this.$store.getters.getLabelContractsSortingPagingOptions },
            set(options) { this.$store.commit('setLabelContractsSortingPagingOptions', options) }
        }
    },
    methods: {
        getSelectedReleasesText(track) {
            if(track.selectedReleases.length == 0) return ''

            if(track.selectedReleases.length > 1) return this.$t('lang_GENERAL_CAPTION_MULTIPLE')
            else {
                // is not working with add new row, because my autocomplete is not setting the correct attribute... 
                // track is the whole thing and inside of this we have "releases"...
                let match = track.releases.find(release => {
                    return release.alvId === track.selectedReleases[0]
                })

                if(match !== undefined) {
                    let temp = match.title
                    temp += ' (EAN: ' + (match.ean !== null ?  match.ean : '-')
                    temp += ', ' + this.$t('lang_GENERIC_CAPTION_CATALOGUE_NUMBER')+ ': ' + (match.catalogueNumber !== null ? match.catalogueNumber : '-') + ')'
                    return temp
                } else return ''
            } 
        },
        getSelectedReleasesTooltip(track) {
            if(track.selectedReleases.length == 0) return ''

            let releases = []
            track.selectedReleases.forEach(selectedRelease => {
                let match = track.releases.find(release => {
                    return release.alvId === selectedRelease
                })
                if(match !== undefined) {
                    let temp = match.title
                    temp += ' (EAN: ' + (match.ean !== null ?  match.ean : '-')
                    temp += ', ' + this.$t('lang_GENERIC_CAPTION_CATALOGUE_NUMBER')+ ': ' + (match.catalogueNumber !== null ? match.catalogueNumber : '-') + ')'
                    releases.push(temp)
                }
            })

            return releases.join(', ')
        },
        async nextPage() {
            await this.$store.dispatch('fetchLabelContractsTracksReleases')
        },
        updatePagingSortingOptions() {
            this.$store.dispatch('fetchLabelContractsTracksReleases')
        }
    }
}
</script>

<style>
.noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }

</style>